/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { success, error } from '@/libs/notification';
import router from '@/router';
import {
  ProductsState,
  ProductsDataState,
  ProductsSubmitDataState,
  ProductReplaceData
} from '@/types/master/product';

import { ElLoading } from 'element-plus';
import { handleAuthorizationError } from '@/libs/apiErrorHandler';
import { getAccessToken } from '@/libs/firebaseAuth';
import { getBaseUrl } from '@/libs/env';

export default {
  namespaced: true,
  state: {
    listData: [],
    replaceData: null
  },
  mutations: {
    setList(state: ProductsState, payload: ProductsDataState[]) {
      state.listData = payload;
    },
    setReplace(state: ProductsState, payload: ProductReplaceData) {
      state.replaceData = payload;
    }
  },
  actions: {
    async fetchByDeviceType(context: any, deviceType: number) {
      await axios
        .get(getBaseUrl() + '/master/products', {
          headers: {
            auth: await getAccessToken(),
            devicetype: deviceType
          }
        })
        .then((response) => {
          const activeList = response.data.filter(
            (data: ProductsDataState) => data.isDeleted === false
          );
          context.commit('setList', activeList);
        })
        .catch(async (e) => {
          if (e.response?.status === 401) {
            await handleAuthorizationError();
          } else {
            error(e.response?.status || '', '製品一覧の取得に失敗しました');
          }
          throw e;
        });
    },
    async fetch(context: any) {
      await axios
        .get(getBaseUrl() + '/master/products', {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          const activeList = response.data.filter(
            (data: ProductsDataState) => data.isDeleted === false
          );
          context.commit('setList', activeList);
          const replaceData: ProductReplaceData = {};
          response.data.forEach((data: ProductsDataState) => {
            replaceData[data.id] = {
              name: data.name,
              productCode: data.productCode,
              jan: data.jan,
              price: data.price,
              productType: data.productType,
              deviceType: data.deviceType
            };
          });
          context.commit('setReplace', replaceData);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
            router.push('/top');
          } else {
            router.push('/error/server');
          }
        });
    },
    async fetchSelectList(context: any, companyGroupId: string) {
      await axios
        .get(getBaseUrl() + '/master/products/price/' + companyGroupId, {
          headers: { auth: await getAccessToken() }
        })
        .then((response) => {
          context.commit('setList', response.data);
          const replaceData: ProductReplaceData = {};
          response.data.forEach((data: ProductsDataState) => {
            replaceData[data.id] = {
              name: data.name,
              productCode: data.productCode,
              jan: data.jan,
              price: data.price,
              productType: data.productType,
              deviceType: data.deviceType
            };
          });
          context.commit('setReplace', replaceData);
        })
        .catch(async (e) => {
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
            router.push('/top');
          } else {
            router.push('/error/server');
          }
        });
    },
    async submit(context: any, payload: ProductsSubmitDataState) {
      const loadingInstance = ElLoading.service({ fullscreen: true });
      await axios
        .post(getBaseUrl() + '/master/products', payload, {
          headers: { auth: await getAccessToken() }
        })
        .then(() => {
          success('Success', '製品情報登録に成功しました。');
          router.push('/master/product');
        })
        .catch(async (e) => {
          loadingInstance.close();
          if (e.response.status === 401) {
            await handleAuthorizationError();
          } else if (e.response.status < 500) {
            error(e.response.status);
          } else {
            router.push('/error/server');
          }
        });
    }
  }
};
